import React from "react";

export default function FromItem(props) {
  return (
    <div class="widget-chat-item with-media left">
      <div class="widget-chat-media">
        <img alt="" src={`api/General/Image/${props.from}`} />
      </div>
      <div class="widget-chat-info">
        <div class="widget-chat-info-container">
           <div class="widget-chat-message">
            {props.message}
          </div>
          <div class="widget-chat-time">6:00PM</div>
        </div>
      </div>
    </div>
  );
}



// WEBPACK FOOTER //
// ./src/pages/Chat/FromItem.js